// src/components/layouts/root-layout.tsx
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from '@/components/navigation/navbar';
import { Footer } from '@/components/navigation/footer';
import { useUser } from '@clerk/clerk-react';
import { SampleDataBanner } from '@/components/sample-data-banner';
import ErrorBoundary from '@/components/error-boundary';
import { Toaster } from '@/components/ui/toaster';
import { useCampaignData } from '@/contexts/campaign-data';
import { StickyFeedback } from '@/components/sticky-feedback';

const DEBUG = process.env.NODE_ENV === 'development'

// Path configurations
const NO_BANNER_PATHS = ['/4cs', '/cpd', '/scary', '/test', '/prompt', '/brief', '/data', '/mastery', '/pmax', '/sales', '/slides'];

export default function RootLayout() {
  const { user, isLoaded } = useUser();
  const location = useLocation();
  const { useSampleData } = useCampaignData();

  const isOnNoBannerPage = NO_BANNER_PATHS.some(path => location.pathname.startsWith(path));
  const shouldShowBanner = useSampleData && !isOnNoBannerPage;

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen bg-background font-sans antialiased">
        <div className="relative flex min-h-screen flex-col">
          <Navbar />

          <main className="flex-1 container mx-auto max-w-8xl px-4 sm:px-6 lg:px-8 py-8">
            {shouldShowBanner && <SampleDataBanner />}
            <Outlet />
          </main>

          <Footer />
        </div>
        <StickyFeedback />
        <Toaster />
      </div>
    </ErrorBoundary>
  );
}